import { useNavigate } from 'react-router-dom'
import { useI18n } from 'builder/hooks/useI18n'
import * as Styles from './styles'

type Props = {
  onLinkClick: () => void
}

export const Nav = ({ onLinkClick }: Props) => {
  const { i18n } = useI18n()
  const navigate = useNavigate()

  return (
    <Styles.Container data-testid="onboarding-nav">
      <Styles.Logo onClick={() => navigate('/', { replace: true })} data-testid="onboarding-logo" />
      <Styles.Link onClick={onLinkClick} data-testid="onboarding-skip-link">
        {i18n.t('builder.provision_users.nav.skip')}
      </Styles.Link>
    </Styles.Container>
  )
}
